import React, {FC, useState} from "react";
import {AiOutlineClose, AiOutlineMenu} from "react-icons/ai"
import {Link} from "react-router-dom";

export const NavbarMenu: FC = () => {
    const [nav, setNav] = useState(false);

    const handleNav = () => {
        setNav(!nav);
    }

    return (
        <div className="w-full flex justify-center flex-col absolute top-0 z-10">
            <div className="p-4 grow flex flex-row-reverse text-white">
                <div onClick={handleNav} className='block z-10'>
                    {nav ? (<AiOutlineClose className="text-black z-20 md:text-white" size={30}/>) : (
                        <AiOutlineMenu size={30}/>)}
                </div>
            </div>
            <div className="md:hidden">
                <div
                    className={nav ? "absolute top-0 left-0 right-0 bottom-0 flex justify-center items-center w-full h-screen text-center bg-white "
                        : "absolute top-0 right-0 left-[-100%] bottom-0 flex justify-center items-center w-full h-screen text-center bg-white"}>
                    <ul className="p-4 uppercase">
                        <li className="p-4 border-b border-gray-600">
                            <Link to='/privacypolicy' className='nav-link'>Privacy Policy</Link>
                        </li>
                        <li className="p-4 border-b border-gray-600">
                            <Link to='/imprint' className='nav-link'>Imprint</Link>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="hidden md:flex flex-row-reverse">
                <div className={nav ? "flex flex-row-reverse" : "fixed right-[-100%]"}>
                    <div className={nav ? "w-full flex grow md:flex-row-reverse pr-4" : "fixed right-[-100%]"}>
                        <div className=" h-full md:rounded bg-white">
                            <ul className="p-4 uppercase">
                                <li className="p-4 border-b border-gray-600">
                                    <Link to='/privacypolicy' className='nav-link'>Privacy Policy</Link>
                                </li>
                                <li className="p-4 border-b border-gray-600">
                                    <Link to='/imprint' className='nav-link'>Imprint</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};
